import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import type { Intervention } from 'modules/entity/subEntities/intervention/types';
import { uniq } from 'utils/utils';
import { SEVERITY } from 'modules/entity/constants';
import { fetchEntitySuccess } from 'modules/entity/actions';
import { answerWorksSuccess } from 'modules/entity/subEntities/intervention/actions/works';
import type { IdsState } from './ids';

export type GroupIdsState = { [groupId: string]: IdsState };

type EntityChecklists = Pick<Intervention, 'checklists' | 'displayItemsWithoutPrice'>;

const updateFromIntervention = (_: GroupIdsState, { payload: intervention }: { payload: EntityChecklists }): GroupIdsState => {
  const { checklists = [], displayItemsWithoutPrice = true } = intervention;
  return checklists.reduce<GroupIdsState>((acc, { checklistGroupId, type, items = [] }) => {
    if (checklistGroupId) {
      return {
        ...acc,
        [checklistGroupId]: {
          ...(acc[checklistGroupId] ?? {}),
          [type]: uniq([
            ...(acc[checklistGroupId]?.[type] ?? []),
            ...items.flatMap(({ advices = [] }) =>
              advices.reduce<Array<string>>((adviceAcc, { adviceId, severity, price }) => {
                if (price > 0 || displayItemsWithoutPrice || severity === SEVERITY.OFFERED) {
                  adviceAcc.push(adviceId);
                }
                return adviceAcc;
              }, [])),
          ]),
        },
      };
    }
    return acc;
  }, {});
};

export default createReducer({}, (builder) => {
  builder.addMatcher(isAnyOf(fetchEntitySuccess.match, answerWorksSuccess.match), updateFromIntervention);
});
